import type { Edge, EdgeProps, HandleType } from "@xyflow/react";

export type RuleEdgeType =
  | "default"
  | "decision-true"
  | "decision-false"
  | "loop-start"
  | "loop-end"
  | "loop-for-each-return"
  /** Sub-canvas only: Continue sentinel `out` → Loop Start `in` (synthetic, not persisted). */
  | "loop-continue-to-start"

export interface RuleEdgeData extends Record<string, unknown> {
  label?: string;
  color?: string;
  /** When true, the + add button on this edge is not rendered. */
  disableAddButton?: boolean;
  /**
   * With a label: place the + along the edge after the pill (toward the target) and before the
   * arrow marker. Ignores the default “below the pill” placement.
   */
  addButtonBetweenPillAndMarker?: boolean;
  /** Override fields so the EdgeAddButton in BaseEdge uses the correct context
   *  (needed for synthetic loop-portal edges whose `source` is a fake portal ID). */
  addButtonSourceNodeId?: string;
  addButtonSourceHandleId?: string | null;
  addButtonTargetNodeId?: string;
  addButtonEdgeId?: string;
}

export type RuleEdge = Edge<RuleEdgeData, RuleEdgeType>;

export type RuleEdgeProps = EdgeProps<RuleEdge>;

/** Outgoing decision branches: only the target may be reconnected; outputs on the decision stay fixed. */
export function reconnectableForEdgeType(type: RuleEdgeType): HandleType | undefined {
	if (type === "decision-true" || type === "decision-false") return "target";
	return undefined;
}
